<div class="!relative !z-20 !min-w-0" data-address-autocomplete>
    <label *ngIf="label"
           class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600"
           [class.required]="required"
           [attr.for]="inputId || null">
        {{ label }}
    </label>
    <div class="!flex !h-11 !min-h-11 !overflow-hidden !rounded-xl !border !border-solid !border-slate-200 !bg-white focus-within:!border-primary focus-within:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]">
        <button type="button"
                class="!m-0 !inline-flex !h-full !shrink-0 !appearance-none !items-center !justify-center !border-0 !border-r !border-solid !border-slate-200 !bg-slate-50 !px-3 !text-slate-500 !shadow-none hover:!bg-slate-100 hover:!text-primary focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-inset focus-visible:!ring-primary"
                aria-label="Cerca indirizzo"
                [disabled]="isSearchingAddress"
                (click)="searchAddress()">
            <span *ngIf="isSearchingAddress" class="spinner-border spinner-border-sm" role="status"></span>
            <i *ngIf="!isSearchingAddress" class="bi bi-search" aria-hidden="true"></i>
        </button>
        <input type="text"
               class="!m-0 !box-border !h-full !min-h-0 !min-w-0 !flex-1 !appearance-none !border-0 !bg-white !px-3.5 !py-0 !text-base !text-slate-800 !shadow-none !outline-none focus:!ring-0"
               role="combobox"
               autocomplete="off"
               [id]="inputId"
               [name]="name"
               [required]="required"
               [placeholder]="placeholder"
               [ngModel]="value"
               (ngModelChange)="onAddressChange($event)"
               (focus)="onAddressFocus()"
               (keydown)="onAddressKeydown($event)"
               aria-autocomplete="list"
               [attr.aria-expanded]="isAddressDropdownOpen"
               [attr.aria-controls]="inputId ? inputId + '-results' : null"/>
    </div>

    <div *ngIf="isAddressDropdownOpen"
         [id]="inputId ? inputId + '-results' : null"
         role="listbox"
         class="!absolute !left-0 !top-full !z-30 !mt-1.5 !w-full !overflow-hidden !rounded-xl !border !border-solid !border-slate-200 !bg-white !shadow-[0_12px_32px_rgba(15,23,42,0.12)] md:!w-[32rem]">
        <p class="!mb-0 !px-3.5 !py-3 !text-sm !text-slate-400"
           *ngIf="isSearchingAddress && addressResults.length === 0 && !addressSearchError">
            Ricerca in corso...
        </p>
        <p class="!mb-0 !px-3.5 !py-3 !text-sm !text-slate-500"
           *ngIf="!isSearchingAddress && addressSearchError">
            {{ addressSearchError }}
        </p>
        <ul class="!m-0 !max-h-64 !list-none !overflow-y-auto !p-0" *ngIf="addressResults.length > 0">
            <li *ngFor="let result of addressResults; let i = index"
                class="!m-0 !border-0 !border-b !border-solid !border-slate-100 last:!border-b-0">
                <button type="button"
                        role="option"
                        class="!m-0 !flex !w-full !appearance-none !items-start !gap-3 !border-0 !px-3.5 !py-2.5 !text-left !shadow-none hover:!bg-slate-50 focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-inset focus-visible:!ring-primary"
                        [ngClass]="i === highlightedAddressIndex ? '!bg-primary-soft' : '!bg-white'"
                        [attr.aria-selected]="i === highlightedAddressIndex"
                        (mousedown)="$event.preventDefault()"
                        (click)="selectAddress(result)">
                    <i class="bi bi-geo-alt !mt-0.5 !shrink-0 !text-slate-400" aria-hidden="true"></i>
                    <span class="!flex !min-w-0 !flex-col !gap-0.5">
                        <span class="!text-sm !font-semibold !leading-snug !text-slate-800">{{ getAddressTitle(result) }}</span>
                        <span class="!text-xs !leading-snug !text-slate-500" *ngIf="getAddressSubtitle(result)">{{ getAddressSubtitle(result) }}</span>
                    </span>
                </button>
            </li>
        </ul>
    </div>

    <p *ngIf="hint" class="!mb-0 !mt-1.5 !text-xs !leading-snug !text-slate-400">{{ hint }}</p>
</div>
